/**
 * DescriptionHeaderContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled detail background container.
 */
const DescriptionHeaderContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default withOpacity(DescriptionHeaderContainer);
